"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionStore = require("@/api/distributionStore");
var _systemSetting = require("@/api/systemSetting");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var IMAGE_LIMIT = 6;

// images 在库里存 JSON 字符串；历史数据可能是单个地址或空串，统统兜住
function parseImages(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [String(parsed)];
  } catch (e) {
    return [raw];
  }
}
var _default = exports.default = {
  name: 'DistributionStoreInfo',
  data: function data() {
    return {
      contractVisible: false,
      contractLoading: false,
      contractBlobUrl: '',
      contractError: '',
      loading: false,
      saving: false,
      IMAGE_LIMIT: IMAGE_LIMIT,
      form: {
        imageList: []
      },
      rules: {
        storeName: [{
          required: true,
          message: '请输入门店名称',
          trigger: 'blur'
        }],
        contactPhone: [{
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.load();
  },
  methods: {
    /**
     * 合同 PDF 在 OSS 默认域名上会被强制下载，先取成 Blob 再以 application/pdf 内嵌显示。
     */
    previewContract: function previewContract() {
      var _this = this;
      this.revokeContract();
      this.contractError = '';
      this.contractVisible = true;
      this.contractLoading = true;
      fetch(this.form.leaderContractUrl).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.blob();
      }).then(function (blob) {
        _this.contractBlobUrl = URL.createObjectURL(new Blob([blob], {
          type: 'application/pdf'
        }));
      }).catch(function () {
        _this.contractError = '无法在线加载合同（文件服务器未允许跨域访问），请点「新窗口打开」查看或下载。';
      }).finally(function () {
        _this.contractLoading = false;
      });
    },
    revokeContract: function revokeContract() {
      if (this.contractBlobUrl) URL.revokeObjectURL(this.contractBlobUrl);
      this.contractBlobUrl = '';
    },
    openContractNew: function openContractNew() {
      window.open(this.contractBlobUrl || this.form.leaderContractUrl, '_blank');
    },
    load: function load() {
      var _this2 = this;
      this.loading = true;
      (0, _distributionStore.storeMineApi)().then(function (data) {
        _this2.form = _objectSpread(_objectSpread({}, data || {}), {}, {
          imageList: parseImages(data && data.images)
        });
        _this2.$nextTick(function () {
          return _this2.$refs.form && _this2.$refs.form.clearValidate();
        });
      }).catch(function () {}).finally(function () {
        _this2.loading = false;
      });
    },
    uploadImage: function uploadImage(param) {
      var _this3 = this;
      var formData = new FormData();
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading'
      });
      (0, _systemSetting.fileImageApi)(formData, {
        model: 'store',
        pid: 0
      }).then(function (res) {
        _this3.form.imageList.push(res.url);
      }).catch(function () {}).finally(function () {
        return loading.close();
      });
    },
    removeImage: function removeImage(idx) {
      this.form.imageList.splice(idx, 1);
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this4.saving = true;
        // 只传门店自己能改的字段，编号 / 状态 / 团长后端也不收
        (0, _distributionStore.storeMineSaveApi)({
          storeName: _this4.form.storeName,
          contactName: _this4.form.contactName,
          contactPhone: _this4.form.contactPhone,
          address: _this4.form.address,
          images: _this4.form.imageList.length ? JSON.stringify(_this4.form.imageList) : '',
          remark: _this4.form.remark
        }).then(function () {
          _this4.$message.success('保存成功');
          _this4.load();
        }).catch(function () {}).finally(function () {
          _this4.saving = false;
        });
      });
    }
  }
};